"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTypeMessage = 'MSG';
exports.MessageTypeOpenSecureChannel = 'OPN';
exports.MessageTypeCloseSecureChannel = 'CLO';
